const allowedItemStatuses: Array<string> = JSON.parse(
  process.env.GATSBY_DIRECTUS_ALLOWED_ITEM_STATUSES ?? "[]"
);

export const isStatusAllowed = (status: string) =>
  !!allowedItemStatuses.find((s) => s === status);

export const compareByPresentationOrder = (
  a: { presentationOrder: number },
  b: { presentationOrder: number }
) => {
  const subtract = a.presentationOrder - b.presentationOrder;
  if (subtract < 0) {
    return -1;
  } else if (subtract > 0) {
    return 1;
  }
  return 0;
};

// This assumes that any internal link (intended for Gatsby)
// will start with exactly one slash, and that anything else is external.
export const isInternalHref = (href) => /^\/(?!\/)/.test(href);

export const groupBy = (arr, criteria) => {
  const newObj = arr.reduce(function (acc, currentValue) {
    if (!acc[currentValue[criteria]]) {
      acc[currentValue[criteria]] = [];
    }
    acc[currentValue[criteria]].push(currentValue);
    return acc;
  }, {});
  return newObj;
};

/**
 * @description Extract the ID of a file from it's URL. An ID consists of numbers, 
 * letters, and dashes. Dashes are fixed, letters and numbers are generated randomly: ' * x1x1x1x1-y2y2-x1x1-y2y2-x1x1x1x1x1x1. If an ID is not found then return null.
 * @param url string
 */
export const getFileIdFromFileUrl = (url: string) => {
  const fileIdRegEx = new RegExp('(.){8}-(.){4}-(.){4}-(.){4}-(.){12}');
  const regExExecResultArray: RegExpExecArray | null = fileIdRegEx.exec(url);
  if (regExExecResultArray && regExExecResultArray?.length > 0) return regExExecResultArray[0];
  console.error(`Could not find an ID from the URL ${url}. Found: ${regExExecResultArray}`);
  return null;
}

// Set variable isLoggedIn to local store with TTL. Used in test sites and prod beta.
export function setLoggedInUserWithTtl(key: string, value: string, ttlInHours: number) {
  const ttlInSeconds = ttlInHours * 3600;
  const now = Date.now();
  const item = {
    value: value,
    expiry: now + ttlInSeconds * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

// Get variable isLoggedIn from local store with TTL check.
export function getLoggedInUserWithTtl(key: string): boolean {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return false;

  const item = JSON.parse(itemStr);
  const now = Date.now();

  if (now > item.expiry) {
    localStorage.removeItem(key);
    return false;
  }

  return item.value === 'true';
}
